import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';
import _, { chain, partial, split, isEmpty } from 'lodash';

import { routes } from '../../routes';
import { LOCALES, DEFAULT_LOCALE } from '../../constants/locale';
import { PATH, REDIRECT_AFTER_LOGIN_ALLOWED_PATH } from '../../constants/path';

import { changeCurrentLocale } from '../../services/i18n/actions';
import { fetchEbonPartners } from '../../services/ebon/actions';
import { fetchPartnersIfNeeded } from '../../services/partner/actions';
import { fetchCategoriesIfNeeded } from '../../services/category/actions';
import { loginUser } from '../../services/authentication/login/actions';

import {
    catchRedirectUri,
    catchScoreHash,
    catchSource,
    verifyUserIdIntegrity
} from '../../utils/plebicardUtils';
import { mapRoutes } from '../../utils/routeUtils';
import { getLocaleFromRoutes } from '../../services/i18n/utils';

const ConnectedSwitch = connect(state => ({
    location: state.location
}))(Switch);

class RouterComponent extends React.Component {
    componentWillMount() {
        this.changeCurrentLocaleIfNeeded(this.props);
        const {
            location: { search }
        } = this.props;

        const values =
            search &&
            chain(search)
                .replace('?', '') // a=b454&c=dhjjh&f=g6hksdfjlksd
                .split('&') // ["a=b454","c=dhjjh","f=g6hksdfjlksd"]
                .map(partial(split, _, '=', 2)) // [["a","b454"],["c","dhjjh"],["f","g6hksdfjlksd"]]
                .fromPairs() // {"a":"b454","c":"dhjjh","f":"g6hksdfjlksd"}
                .value();

        const redirectUri = values && values.redirect_uri;
        const label = values && values.label;
        const userId = values && values.userId;
        const score = values && values.score;
        const hash = values && values.hash;
        const source = values && values.source;

        catchScoreHash(score, hash);
        catchSource(source);
        catchRedirectUri(redirectUri, label);
        verifyUserIdIntegrity(userId);

        this.redirectToPathname();
    }

    componentDidMount() {
        const {
            fetchPartnersIfNeeded,
            fetchCategoriesIfNeeded,
            fetchEbonPartners,
            loginUser
        } = this.props;

        fetchPartnersIfNeeded();
        fetchCategoriesIfNeeded();
        fetchEbonPartners();

        loginUser();
    }

    componentDidUpdate(prevProps) {
        const { location } = this.props;

        if (prevProps.location !== location) {
            this.changeCurrentLocaleIfNeeded(this.props);
        }

        /* 
            When going back from Monetico page to merchant card using Browser'back button,
            Monetico scripts are not reloading themselves, which cause a blank page
            For now, we reload the page to force the reset.
        */
        if (
            prevProps.location.pathname.includes(PATH.EBON_VALIDATION_PATH) &&
            location.pathname.includes(PATH.MERCHANTPAGE_EBON_PATH)
        ) {
            window.location = `${location.pathname}${location.hash ? location.hash : ''}`;
            window.location.reload(true);
        }
    }

    changeCurrentLocaleIfNeeded({ pathname, locale }) {
        // On vient mettre à jour le store si on arrive avec une url d'un autre langage
        const newLocale = getLocaleFromRoutes(pathname, LOCALES, DEFAULT_LOCALE);

        if (newLocale !== locale) {
            this.props.changeCurrentLocale(newLocale);
            moment.locale(newLocale);
        }
    }

    redirectToPathname = () => {
        const {
            location: { pathname },
            history
        } = this.props;
        if (REDIRECT_AFTER_LOGIN_ALLOWED_PATH.some(path => pathname.startsWith(path))) {
            history.push(pathname);
        }
    };

    render() {
        return <ConnectedSwitch>{mapRoutes(routes)}</ConnectedSwitch>;
    }
}

const mapStateToProps = state => {
    return {
        pathname: state.routing.location.pathname,
        locale: state.i18n.locale,
        isAuthed: !isEmpty(state.authentication.token),
        isAuthFetching: state.authentication.fetching
    };
};

const mapDispatchToProps = {
    fetchPartnersIfNeeded,
    fetchEbonPartners,
    fetchCategoriesIfNeeded,
    changeCurrentLocale,
    loginUser
};

export default connect(mapStateToProps, mapDispatchToProps)(RouterComponent);



// WEBPACK FOOTER //
// ./src/components/router/RouterComponent.js